import React from 'react';
import {Link } from 'react-router-dom';

import { Box, Button, Heading, Stack, Image } from '@chakra-ui/react';
import Footer from './components/Footer';

const imgUrl = `/images/${process.env.REACT_APP_PROJECT_ID}`;

function Sponsor() {
  return (
    <Box display={'flex'} flexDirection='column' alignItems={'center'}>
      <Heading m={5} textAlign='center' color='white' fontSize={'4xl'}>
        I nostri sponsor
      </Heading>
      <Stack direction={['column']} spacing='24px'>
        <Image w={'300px'} src={`${imgUrl}/sponsor/page-box86.jpg`} alt='Sponsor' />
        <Image w={'300px'} src={`${imgUrl}/sponsor/page-pole-studio.jpg`} alt='Sponsor' />
        <Image w={'300px'} src={`${imgUrl}/sponsor/page-seardo.jpg`} alt='Sponsor' />
        <Image w={'300px'} src={`${imgUrl}/sponsor/page-arizona.jpg`} alt='Sponsor' />
        <Image w={'300px'} src={`${imgUrl}/sponsor/page-easy-shop.jpg`} alt='Sponsor' />
       
      </Stack>
      <Button as={Link} to='/' my={50} size={'lg'}>
        Ritorna alla Home
      </Button>
      <Footer/>
    </Box>
  );
}

export default Sponsor;
